import React from 'react'

import type { TTiveDeviceSource } from '../../../types/tracking'
import { StatusIcon } from '../status-icon'
import { TrackingTimeDisplay } from '../tracking-time-display'

interface ITiveDeviceTrackingInfo {
  trackingSourceData: TTiveDeviceSource
}

/**
 * The component that displays the tive device info in a tooltip
 */
export const TiveDeviceTrackingInfo = (props: ITiveDeviceTrackingInfo) => {
  const { trackingSourceData } = props
  const trackingSourceMetadata = trackingSourceData?.metadata
  const locations = trackingSourceData?.locations

  const humidity = locations?.[locations.length - 1]?.locationInfo.humidity ?? null
  const temperature = locations?.[locations.length - 1]?.locationInfo.temperature ?? null

  return (
    <div className="flex w-full flex-col space-y-2 items-start">
      <p className="text-md font-semibold ">{trackingSourceMetadata?.provider || 'Unsupported tracking link'}</p>

      <p className="max-w-[400px] line-clamp-4">Device ID: {trackingSourceMetadata?.tiveDeviceID}</p>

      <p className="max-w-[400px] line-clamp-4">Humidity: {humidity ?? '-'}</p>

      <p className="max-w-[400px] line-clamp-4">Temperature: {temperature ?? '-'}</p>

      {!!trackingSourceData.locations?.length && trackingSourceData?.locations?.length > 0 && (
        <TrackingTimeDisplay
          filterReason={trackingSourceData.filterReason}
          lastLocationFetchedAt={trackingSourceData.lastLocationFetchedAt}
          lastLocationTimestamp={trackingSourceData.locations[trackingSourceData.locations.length - 1]?.timestamp}
          wrapper="p"
        />
      )}

      <div className="flex items-center space-x-2">
        <StatusIcon isPositive={Boolean(trackingSourceData.locations?.length)} />
        <span>Status: {trackingSourceData?.locations?.length ? 'Tracking' : 'Not tracking'}</span>
      </div>
    </div>
  )
}
